import { Group, Code, Collapse, rem } from "@mantine/core";
import { useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as storesIcon } from "../../../Assets/SVG/Stores.svg";
import { ReactComponent as settingsIcon } from "../../../Assets/SVG/Settings.svg";
import { ReactComponent as reportsIcon } from "../../../Assets/SVG/Reports.svg";
import { ReactComponent as insightIcon } from "../../../Assets/SVG/Insight.svg";
import { ReactComponent as usersIcon } from "../../../Assets/SVG/Users.svg";
import { ReactComponent as accountIcon } from "../../../Assets/SVG/User.svg";
import { ReactComponent as helpIcon } from "../../../Assets/SVG/Help.svg";
import { ReactComponent as subscriptionIcon } from "../../../Assets/SVG/Subscription.svg";
import { ReactComponent as preferencesIcon } from "../../../Assets/SVG/Preferences.svg";

import classes from "./Nav.module.css";

const data = [
  { label: "Home", icon: storesIcon, link: "/stores" },
  { label: "Reports", icon: reportsIcon, link: "/reports" },
  { label: "Insight", icon: insightIcon, link: "/insight" },
  {
    label: "Settings",
    icon: settingsIcon,
    links: [
      { label: "Account", icon: accountIcon, link: "/account" },
      { label: "Stores", icon: storesIcon, link: "/users" },
      { label: "Subscription", icon: subscriptionIcon, link: "/subscription" },
      { label: "Preferences", icon: preferencesIcon, link: "/preferences" },
    ],
  },
  { label: "Help", icon: helpIcon, link: "/help" },
];

// close & openedMobile props used to close the Drawer on mobile/small screens
export function Nav({ close, openedMobile }) {
  // Getting the pathname and formatting it to dynamically set the active state of the navlinks
  const path = window.location.pathname;
  const activeLink =
    path.substring(1).charAt(0).toUpperCase() + path.substring(2);

  const [active, setActive] = useState(activeLink);
  const [opened, setOpened] = useState(true);
  const navigate = useNavigate();

  const navlinks = data.map((item) => (
    <>
      <a
        className={classes.link}
        data-active={item.label === active || undefined}
        key={item.label}
        onClick={(event) => {
          event.preventDefault();
          setActive(item.label);
          if (item.link) {
            navigate(item.link);
            if (openedMobile) {
              close();
            }
          } else {
            setOpened((o) => !o);
          }
        }}
      >
        <item.icon className={classes.linkIcon} stroke={1.5} />
        <span>{item.label}</span>
        {item.label === "Settings" && (
          <>
            <IconChevronDown
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(20),
                height: rem(20),
                transform: opened ? "rotate(-180deg)" : "none",
                position: "absolute",
                right: 0,
                marginRight: rem(20),
              }}
            />
          </>
        )}
      </a>
      {item.label === "Settings" && (
        <Collapse in={opened} ml="md">
          {item?.links?.map((innerLink) => (
            <a
              className={classes.link}
              data-active={innerLink.label === active || undefined}
              href={innerLink.link}
              key={innerLink.label}
              onClick={(event) => {
                event.preventDefault();
                setActive(innerLink.label);
                navigate(innerLink.link);
                if (openedMobile) {
                  close();
                }
              }}
            >
              <innerLink.icon className={classes.linkIcon} stroke={1.5} />
              {innerLink.label}
            </a>
          ))}
        </Collapse>
      )}
    </>
  ));

  return (
    <nav className={classes.navbar}>
      <div className={classes.navbarMain}>{navlinks}</div>
    </nav>
  );
}
